export default __webpack_public_path__ + "static/media/license_type_icon.a9112ab6.svg";